import {
  Button,
  Space,
  Paper,
  Flex,
  Group,
  Stack,
  Title,
  Text,
  Textarea,
  TextInput,
} from '@mantine/core';
import {
  hasLength,
  isEmail,
  isNotEmpty,
  useForm,
} from '@mantine/form';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import {
  createFileRoute,
} from '@tanstack/react-router';
import {
  useEffect,
} from 'react';
export const Route = createFileRoute('/_app/_landing/contact')({
  component: RouteComponent,
});

export interface FormValues {
  email: string;
  name: string;
  message: string;
}

const FORM_STORAGE_KEY = 'contact-form-unsent';

function RouteComponent() {
  const contactForm = useForm({
    mode: 'uncontrolled',
    initialValues: {
      name: '',
      email: '',
      message: '',
    },
    validate: {
      name: hasLength({
        min: 2,
      }, 'Enter your name'),
      email: isEmail('Invalid email'),
      message: isNotEmpty('Enter your messge'),
    },
    onValuesChange: (values) => {
      window.localStorage.setItem(
        FORM_STORAGE_KEY,
        JSON.stringify(values),
      );
    },
  });
  const handleMessageSend = contactForm.onSubmit((values) => {
    console.log(values);
  })
  useEffect(() => {
    const storedValue = window.localStorage.getItem(FORM_STORAGE_KEY);
    if (storedValue) {
      try {
        contactForm.setValues(JSON.parse(window.localStorage.getItem(FORM_STORAGE_KEY)!));
      } catch (err) {
        console.warn('Failed to parse stored form value', err);
      }
    }
  }, []);

  return (
    <>
      <Flex
        gap="xl"
        justify="center"
        align="flex-start"
        direction="row"
        wrap="wrap"
      >
        <Stack
          align="flex-start"
          justify="flex-start"
          gap="xl"
          mr="xl"
          miw="30%"
        >
          <Title
            order={ 1 }
            mt="xl"
          >
            Contact Us
          </Title>
          <Text
            span
            fw={ 400 }
            c="transparent.7"
            size="xl"
            mt="xl"
          >
            Send us a message here or use the contact email provided.
            <br />We will get back to you within 24 hours.
          </Text>
          <Text
            span
            fw={ 600 }
            c="transparent.9"
            size="xl"
            mt="xl"
          >
            <MailOutlineIcon
              style={ {
                marginRight: '1vw',
              } }
            />
            { ' ' }
            support@specia.ai
            <br />
            <br />
            <LocationOnIcon
              style={ {
                marginRight: '1vw',
              } }
            />
            { ' ' }
            Level 2 (South), 350 Collins Street, Melbourne
          </Text>
        </Stack>
        <Paper
          shadow="xl"
          radius="lg"
          withBorder
          p="xl"
          mt="xl"
          ml="xl"
          miw="30%"
          w="50%"
        >
          <Stack
            align="stretch"
            justify="flex-start"
            gap="xl"

          >
            <Title
              order={ 2 }
            >
              Send a message
            </Title>
            <form
              onSubmit={ handleMessageSend }
            >
              <TextInput
                withAsterisk
                label="Email"
                placeholder="you@business.domain"
                key={ contactForm.key('email') }
                w="60%"
                mb="lg"
                { ...contactForm.getInputProps('email') }
              />
              <TextInput
                withAsterisk
                label="Name"
                placeholder="Tell us your name"
                key={ contactForm.key('name') }
                w="60%"
                mb="xl"
                { ...contactForm.getInputProps('name') }
              />
              <Textarea
                withAsterisk
                label="Message"
                placeholder="Write your message here"
                autosize
                minRows={ 8 }
                key={ contactForm.key('message') }
                w="100%"
                mb="xl"
                { ...contactForm.getInputProps('message') }
              />
              <Space h="lg" />
              <Group
                justify="flex-end"
                maw="100%"
                grow
              >
                <Button
                  type="submit"
                >
                  Send Message
                </Button>
              </Group>
            </form>
          </Stack>
        </Paper>
      </Flex>
    </>
  );
}
